import { CommonModule, DOCUMENT, Location ,isPlatformBrowser } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,PLATFORM_ID,
    ViewEncapsulation,
} from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Article } from 'app/models/Article';
import { cloneDeep } from 'lodash-es';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Etape } from './../etape';

import { DialogModule } from '@angular/cdk/dialog';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FuseAlertType } from '@fuse/components/alert';
import { LoginService } from 'app/login.service';
import { MarketData } from 'app/models/MarketData';
import { Utilisateur } from 'app/models/Utilisateur';
import { ArticleService } from 'app/shared/article.service';
import { DataService } from 'app/shared/data.service';
import { DirtyComponent } from 'app/shared/dirty-component';
import { ImageService } from 'app/shared/image.service';
import { SharedModule } from 'app/shared/shared.module';
import { UtilisateurService } from 'app/shared/utilisateur.service';
import { environment } from 'environments/environment';
import { QuillModule } from 'ngx-quill';
import { EditorModule } from '@tinymce/tinymce-angular';

@Component({
    selector: 'app-creation-article',
    templateUrl: './creation-article.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatButtonModule,
        DialogModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        RouterModule,
        MatInputModule,
        MatMenuModule,
        MatSidenavModule,
        MatTooltipModule,
        SharedModule,
        MatTabsModule,
        MatProgressBarModule,
        QuillModule,
        CommonModule,
        MatPaginatorModule,
        MatTableModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatRadioModule,
        CommonModule,
        MatBadgeModule,
        MatListModule,
         EditorModule
    ],
})
export class CreationArticleComponent
    implements OnInit, DirtyComponent, OnDestroy
{

 tinyMceConfig = {
  // Configuration de base
  base_url: 'https://cdn.tiny.cloud/1/YOUR-API-KEY/tinymce/7',
  apiKey: 'ocphg99gxkv0mq1o5fqdhba3ue4jy9qvdu5cqdd18of6rbxt',
  
  // Plugins essentiels pour un éditeur complet
  plugins: [
    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
    'insertdatetime', 'media', 'table', 'paste', 'code', 'help', 'wordcount',
    'emoticons', 'template', 'codesample', 'quickbars', 'accordion',
    'pagebreak', 'nonbreaking', 'toc', 'directionality', 'visualchars',
    'noneditable', 'importcss', 'autoresize', 'save', 'autosave'
  ].join(' '),
  
  // Barre d'outils complète
  toolbar: [
    'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | fontcolor backcolor',
    'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
    'table link image media codesample | emoticons charmap | insertdatetime | preview fullscreen',
    'accordion | pagebreak nonbreaking toc | visualblocks visualchars | code save | help'
  ].join(' | '),
  
  // Configuration du menu
  menubar: 'file edit view insert format tools table help',
  
  // Menu contextuel rapide
  quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
  quickbars_insert_toolbar: 'quickimage quicktable | hr pagebreak',
  
  // Configuration des images
  images_upload_handler: (blobInfo: any, success: any, failure: any) => {
    // Implémentez votre logique d'upload d'images ici
    // Exemple basique (à adapter selon votre backend)
    const formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());
    
    // Remplacez par votre endpoint d'upload
    fetch('/api/upload', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(result => {
      success(result.location);
    })
    .catch(error => {
      failure('Upload failed: ' + error.message);
    });
  },
  
  // Configuration des fichiers
  file_picker_types: 'image media file',
  file_picker_callback: (callback: any, value: any, meta: any) => {
    // Implémentez votre sélecteur de fichiers
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', meta.filetype === 'image' ? 'image/*' : '*/*');
    
    input.onchange = (event: any) => {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        callback(reader.result, {
          alt: file.name
        });
      };
      reader.readAsDataURL(file);
    };
    
    input.click();
  },
  
  // Configuration des tableaux
  table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
  table_appearance_options: false,
  table_grid: false,
  table_class_list: [
    {title: 'Table par défaut', value: 'table'},
    {title: 'Table striée', value: 'table table-striped'},
    {title: 'Table bordée', value: 'table table-bordered'}
  ],
  
  // Configuration du contenu
  content_style: `
    body { 
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; 
      font-size: 14px; 
      line-height: 1.6; 
      color: #333; 
      max-width: 800px; 
      margin: 0 auto; 
      padding: 20px; 
    }
    .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
      color: #999;
      font-style: italic;
    }
  `,
  
  // Formats personnalisés
  formats: {
    highlight: {
      inline: 'span',
      classes: 'highlight',
      styles: { backgroundColor: '#ffff00' }
    },
    code: {
      inline: 'code',
      classes: 'code-inline'
    }
  },
  
  // Configuration de la sauvegarde automatique
  autosave_ask_before_unload: true,
  autosave_interval: '30s',
  autosave_prefix: 'tinymce-autosave-{path}{query}-{id}-',
  autosave_restore_when_empty: false,
  autosave_retention: '2m',
  
  // Configuration générale
  height: 500,
  resize: 'both',
  branding: false,
  promotion: false,
  statusbar: true,
  elementpath: true,
  
  // Configuration de la langue (optionnel)
  language: 'fr_FR',
  
  // Configuration du contenu
  entity_encoding: 'raw',
  remove_script_host: false,
  convert_urls: false,
  
  // Configuration des styles
  style_formats: [
    {
      title: 'Titres',
      items: [
        {title: 'Titre 1', format: 'h1'},
        {title: 'Titre 2', format: 'h2'},
        {title: 'Titre 3', format: 'h3'},
        {title: 'Titre 4', format: 'h4'},
        {title: 'Titre 5', format: 'h5'},
        {title: 'Titre 6', format: 'h6'}
      ]
    },
    {
      title: 'Blocs',
      items: [
        {title: 'Paragraphe', format: 'p'},
        {title: 'Citation', format: 'blockquote'},
        {title: 'Div', format: 'div'},
        {title: 'Pré-formaté', format: 'pre'}
      ]
    },
    {
      title: 'Inline',
      items: [
        {title: 'Gras', format: 'bold'},
        {title: 'Italique', format: 'italic'},
        {title: 'Souligné', format: 'underline'},
        {title: 'Barré', format: 'strikethrough'},
        {title: 'Exposant', format: 'superscript'},
        {title: 'Indice', format: 'subscript'},
        {title: 'Code', format: 'code'}
      ]
    }
  ],
  
  // Configuration des templates
  templates: [
    {
      title: 'Email de base',
      description: 'Template d\'email simple',
      content: `
        <p>Bonjour [NOM],</p>
        <p>Votre message ici...</p>
        <p>Cordialement,<br>[SIGNATURE]</p>
      `
    },
    {
      title: 'Article de blog',
      description: 'Structure d\'article',
      content: `
        <h1>Titre de l'article</h1>
        <p><em>Introduction captivante...</em></p>
        <h2>Sous-titre</h2>
        <p>Contenu principal...</p>
        <h2>Conclusion</h2>
        <p>Résumé et call-to-action...</p>
      `
    }
  ],
  
  // Configuration de validation
  valid_elements: '*[*]',
  extended_valid_elements: 'iframe[src|width|height|name|align|class|id|frameborder|scrolling|marginheight|marginwidth]',
  
  // Configuration du paste
  paste_data_images: true,
  paste_as_text: false,
  paste_retain_style_properties: 'color background-color',
  
  // Configuration des liens
  link_assume_external_targets: true,
  link_context_toolbar: true,
  link_quicklink: true,
  
  // Configuration des listes
  lists_indent_on_tab: true,
  
  // Configuration de l'accessibilité
  a11y_advanced_options: true,
  
  // Configuration mobile
  mobile: {
    theme: 'silver',
    plugins: 'autosave lists autolink',
    toolbar: 'undo bold italic styles'
  },
  
  // Callbacks utiles
  init_instance_callback: (editor: any) => {
    console.log('TinyMCE initialisé:', editor.id);
  },
  
  setup: (editor: any) => {
    // Bouton personnalisé
    editor.ui.registry.addButton('customButton', {
      text: 'Custom',
      onAction: () => {
        editor.insertContent('<p>Contenu personnalisé inséré!</p>');
      }
    });
    
    // Événements personnalisés
    editor.on('change', () => {
      console.log('Contenu modifié');
    });
    
    editor.on('keyup', () => {
      console.log('Touche relâchée');
    });
  }
}
    cloud_front = environment.cloud_front_host;
    articleForm: FormGroup;
    @ViewChild('articleNgForm') articleNgForm: NgForm;
    selectedFiles?: FileList;
    currentFile?: File;
    fileInfos?: Observable<any>;
    @ViewChild('courseSteps', { static: true }) courseSteps: MatTabGroup;
    drawerMode: 'over' | 'side' = 'side';
    drawerOpened: boolean = true;
    currentStep: number = 0;
    article: Article;
    totalSteps: number = 5;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _demoSteps: any[] = Etape;
    steps: any[] = Etape;
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    showAlert: boolean = false;
    isDirty = false;
    formFieldHelpers: string[] = [''];
    articleSauvegarde: boolean = false;
    articleNonSauvegarde: boolean = false;
    idUtilisateurConnecte: string = '';
    isLogged: boolean;
    username: string;
    actifs: MarketData[] = [];
    selectedActifNom: any;
    selectedFile: File | null = null;
    photoArticle: string;
    allowedUsernames: string[] = ['fida12', 'anis habibi','mannana dbibi'];
    isButtonEnabled: boolean = false;

    constructor(
        public location: Location,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _changeDetectorRef: ChangeDetectorRef,
        @Inject(DOCUMENT) private _document: Document,
        private imageService: ImageService,
        private articleService: ArticleService,
        private utilisateurService: UtilisateurService,
        private loginService: LoginService,
        private dataService: DataService, @Inject(PLATFORM_ID) private platformId: Object
    ) {}
    canDeactivate() {
        return this.isDirty;
    }

    ngOnInit() {
        this.articleForm = new FormGroup({
            contenu: new FormControl('', [Validators.required]),
            nom: new FormControl('', [Validators.required]),
            image: new FormControl(''),
            type: new FormControl('article', [Validators.required]),
            auteur: new FormControl(''),
            themeArticle: new FormControl(''),
            themeNews: new FormControl(''),
            description: new FormControl('', [Validators.required]),
            actif: new FormControl(''),
            etat: new FormControl('VALIDE', [Validators.required]),
        });
        
        // Conditional Validators (optional)
        this.articleForm.get('type').valueChanges.subscribe(value => {
            if (value === 'article') {
              this.articleForm.get('themeNews').reset();
            } else if (value === 'news') {
              this.articleForm.get('themeArticle').reset();
            }
          });
        this.articleForm.valueChanges.subscribe((e) => (this.isDirty = true));
        this.fileInfos = this.articleService.getFiles();
        this.steps = cloneDeep(this._demoSteps);
        // Subscribe to media changeslo
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Set the drawerMode and drawerOpened
                if (matchingAliases.includes('lg')) {
                    this.drawerMode = 'side';
                    this.drawerOpened = true;
                } else {
                    this.drawerMode = 'over';
                    this.drawerOpened = false;
                }

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
        this.recupererPopulaires();
        this.checkButtonStatus();

    }
    checkButtonStatus(): void {
        this.username = this.loginService.getUsername();
        if (this.allowedUsernames.includes(this.username)) {
          this.isButtonEnabled = true;
        }
      }
    retour() {
        this.location.back();
    }
    onActifNomSelectionChange(selectedActifNom: string | string[]) {
        if (Array.isArray(selectedActifNom)) {
            this.selectedActifNom.setValue(selectedActifNom.join(', '));
        } else {
            this.selectedActifNom.setValue(selectedActifNom);
        }
    }
    recupererPopulaires() {
        this.dataService
            .recupererTout()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (data: MarketData[]) => {
                    this.actifs = data;
                },
            });
    }
    async soumettre() {
        try {
          await this.uploadImageAndSaveArticle();
          this.goToNextStep();
        } catch (error) {
          console.log('Error during submission:', error);
        }
      }
    async uploadImageAndSaveArticle() {
        if (this.selectedFile) {
          return new Promise<void>((resolve, reject) => {
            this.imageService
              .uploadImageInFolder(this.selectedFile, 'Article')
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe({
                next: (response) => {
                  const imageUrl = response.imagePath;
                  this.articleForm.controls['image'].setValue(imageUrl);
                  this.enregistrerArticle().then(resolve).catch(reject);
                },
                error: (err) => {
                  console.log('Error uploading image:', err);
                  reject(err);
                },
              });
          });
        } else {
          console.log('No file selected');
        }
      }
    
      async enregistrerArticle(): Promise<void> {
        try {
          const formData = this.articleForm.value;
          
          // Préparation des données communes
          const commonData = {
            nom: formData.nom,
            type: formData.type,
            contenu: formData.contenu,
            image: formData.image,
            auteur: formData.auteur,
            date: formData.date,
            etat: formData.etat,
            actif: formData.actif,
            description: formData.description
          };
      
          // Ajout des champs spécifiques
          const dataToSend = {
            ...commonData,
            ...(formData.type === 'news' && { themeNews: formData.themeNews }),
            ...(formData.type === 'article' && { themeArticle: formData.themeArticle })
          };
      
          // Vérification de l'authentification
          this.isLogged = this.loginService.getIsLogged();
          if (!this.isLogged) {
            throw new Error('Utilisateur non connecté');
          }
      
          // Récupération de l'utilisateur
          this.username = this.loginService.getUsername();
          const utilisateurs = await this.utilisateurService
            .getUtilisateurByUsername(this.username)
            .pipe(takeUntil(this._unsubscribeAll))
            .toPromise();
      
          if (!utilisateurs || utilisateurs.length === 0) {
            throw new Error('Utilisateur introuvable');
          }
      
          this.idUtilisateurConnecte = utilisateurs[0].userId;
          dataToSend.auteur = this.idUtilisateurConnecte;
      
          // Envoi selon le type
          if (formData.type === 'news') {
            await this.articleService.enregistrerNews(dataToSend)
              .pipe(takeUntil(this._unsubscribeAll))
              .toPromise();
          } else if (formData.type === 'article') {
            await this.articleService.enregistrerArticle(dataToSend)
              .pipe(takeUntil(this._unsubscribeAll))
              .toPromise();
          } else {
            throw new Error('Type d\'article non reconnu');
          }
      
          this.articleSauvegarde = true;
        } catch (err) {
          this.articleNonSauvegarde = true;
          console.error('Erreur lors de l\'enregistrement:', err);
          throw err; // Propagation de l'erreur
        }
      }
    
    
    selectFile(event: any): void {
        this.selectedFile = event.target.files[0];
        if (this.selectedFile) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.photoArticle = e.target.result;
            };
            reader.readAsDataURL(this.selectedFile);
        }
    }

    openInput() {
        document.getElementById('fileInput').click();
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Go to given step
     *
     * @param step
     */
    goToStep(step: number): void {
        // Set the current step
        this.currentStep = step;

        // Go to the step
        this.courseSteps.selectedIndex = this.currentStep;

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Go to previous step
     */
    goToPreviousStep(): void {
        // Return if we already on the first step
        if (this.currentStep === 0) {
            return;
        }

        // Go to step
        this.goToStep(this.currentStep - 1);

        // Scroll the current step selector from sidenav into view
        this._scrollCurrentStepElementIntoView();
    }

    /**
     * Go to next step
     */
    goToNextStep(): void {
        // Return if we already on the last step
        if (this.currentStep === this.totalSteps - 1) {
            return;
        }

        // Go to step
        this.goToStep(this.currentStep + 1);

        // Scroll the current step selector from sidenav into view
        this._scrollCurrentStepElementIntoView();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Scrolls the current step element from
     * sidenav into the view. This only happens when
     * previous/next buttons pressed as we don't want
     * to change the scroll position of the sidebar
     * when the user actually clicks around the sidebar.
     *
     * @private
     */
    private _scrollCurrentStepElementIntoView(): void {
        // Wrap everything into setTimeout so we can make sure that the 'current-step' class points to correct element
        setTimeout(() => {
            // Get the current step element and scroll it into view
            const currentStepElement =
                this._document.getElementsByClassName('current-step')[0];
            if (currentStepElement) {
                currentStepElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        });
    }
}
